import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API } from "../Api";
import webdesign from '../Assets/webdesing.png';
import digi from '../Assets/digitalMarget.png';
import fullstack from '../Assets/fullstack.png';
import LiCardLoader from "./Loader/ListLoader";

const CourseCard = () => {
  const [bcourse, setbCourse] = useState([]);
  const [pcourse, setpCourse] = useState([]);
  const [buicourse, setbuiCourse] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCourse = async () => {
    try {
      const res = await axios.get(`${API}/api/courses`);
      const p = res.data
        ?.filter((val) => val.type === "Professional")
        ?.map((val) => ({ courseName: val.courseName, id: val._id }));
      const bui = res.data
        ?.filter((val) => val.type === "Advance")
        ?.map((val) => ({ courseName: val.courseName, id: val._id }));
      const b = res.data
        ?.filter((val) => val.type === "Basic")
        ?.map((val) => ({ courseName: val.courseName, id: val._id }));

      setbCourse(b);
      setpCourse(p);
      setbuiCourse(bui);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(true);
    }
  };

  useEffect(() => {
    fetchCourse();
  }, []);

  const courses = [
    { type: "Basic", image: webdesign, list: bcourse, colorClass: "ccd-blue", content: 'Upgrade your skill' },
    { type: "Professional", image: fullstack, list: pcourse, colorClass: "ccd-green" , content: "Get Placed in IT" },
    { type: "Business", image: digi, list: buicourse, colorClass: "ccd-purple", content: "Start Your Own Business" },
  ];

  return (
    <div className="ccd-container">
      <div className="ccd-grid">
        {courses.map((course, idx) => (
          <div key={idx} className="flip-card">
            <div className="flip-card-inner">
              {/* Front */}
              <div className="flip-card-front" style={{background: `url(${course.image})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover'}}>
               
                <h3 className="ccd-type">{course.type}</h3>
                <p>{course.content}</p>
              </div>

              {/* Back */}
              <div className="flip-card-back">
                <ul className="ccd-list">
                  {!loading
                    ? course.list.map((item, i) => (
                        <Link key={i} to={`/course/${item.id}`}>
                          <li className={`ccd-item ${course.colorClass}`}>
                            {item.courseName}
                          </li>
                        </Link>
                      ))
                    : <LiCardLoader />}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        .ccd-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 30px;
          justify-content: center;
        }



        .flip-card {
          background-color: transparent;
          width: 280px;
          min-height: 350px;
          perspective: 1000px;
        }

        .flip-card-inner {
          position: relative;
          width: 100%;
          height: 100%;
          text-align: center;
          transition: transform 0.8s ease-in-out;
          transform-style: preserve-3d;
          border-radius: 16px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.2);
        }

        .flip-card:hover .flip-card-inner {
          transform: rotateY(180deg);
        }

        .flip-card-front, .flip-card-back {
          position: absolute;
          width: 100%;
          height: 100%;
          backface-visibility: hidden;
          border-radius: 16px;
          overflow: hidden;
        }

        .flip-card-front {
          background: #1F2661;
          color: white;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-transform: uppercase;
         
          
        }
          .flip-card-front  h2 {
          font-size: 25px;
          }

           .flip-card-front  p {
           font-size: 17px;
           }
        .flip-card-front img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 12px;
        }

        .flip-card-back {
          background: #fff;
          color: white;
          transform: rotateY(180deg);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 20px;
        }

        .ccd-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .ccd-item {
          margin: 5px 0;
          padding: 8px 12px;
          border-radius: 8px;
          transition: background 0.3s ease;
          cursor: pointer;
        }

        .ccd-item.ccd-blue:hover { background: #f6f8fcff; }
        .ccd-item.ccd-green:hover { background: #f0f7f2ff; }
        .ccd-item.ccd-purple:hover { background: #f3eefbff; }

      `}</style>
    </div>
  );
};

export default CourseCard;
